@if (visible$ | async) {
  <div
    class="consent-bar"
    role="region"
    aria-label="Zgoda na analitykę"
    data-clarity-unmask="true"
  >
    <p class="consent-bar__text">
      Używamy Microsoft Clarity, aby zobaczyć, jak korzystasz z panelu (nagrania sesji i mapy kliknięć), i na tej
      podstawie go ulepszać. Dane osobowe kursantów i użytkowników są w nagraniach maskowane. Czy zgadzasz się na
      analityczne pliki cookie? Decyzję zmienisz później w menu konta, w zakładce „Prywatność”.
      @if (privacyPolicyUrl) {
        <a [href]="privacyPolicyUrl" target="_blank" rel="noopener">Polityka prywatności</a>
      }
    </p>
    <div class="consent-bar__actions">
      <p-button
        label="Odrzuć"
        severity="secondary"
        [outlined]="true"
        (onClick)="decide('denied')"
        data-clarity-unmask="true"
      />
      <p-button label="Zgadzam się" (onClick)="decide('granted')" data-clarity-unmask="true" />
    </div>
  </div>
}
